import { render, staticRenderFns } from "./InvoiceRectItem.vue?vue&type=template&id=0e23bee4&scoped=true&"
import script from "./InvoiceRectItem.vue?vue&type=script&lang=ts&"
export * from "./InvoiceRectItem.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceRectItem.vue?vue&type=style&index=0&id=0e23bee4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e23bee4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VSimpleTable,VTextField,VTooltip})
